import { render, staticRenderFns } from "./Rotation.vue?vue&type=template&id=19257675&scoped=true&"
import script from "./Rotation.vue?vue&type=script&lang=js&"
export * from "./Rotation.vue?vue&type=script&lang=js&"
import style0 from "./Rotation.vue?vue&type=style&index=0&id=19257675&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19257675",
  null
  
)

export default component.exports